import { useState, useEffect, useMemo } from "react";

// formik components
import { Formik, Form } from "formik";

// toast notifications
import { toast } from "react-toastify";

// Material UI components
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Page components

// API queries
import { useCountryLocCodes } from "api/features/country/queries";
import { useExportPrevProjData } from "api/features/export/queries";

// Contexts
import { useUserContext } from "contexts/contextUser";
import { useFormPrevProjContext } from "contexts/contextFormPrevProj";

import validations from "../../schemas/validations";
import getForm from "../../schemas/form";

import ExportProjectionsForm from "./sections/ExportProjectionsForm";

function ExportPrevProjForm(): JSX.Element {
  const { liveFormValues } = useFormPrevProjContext();

  const { data: countryLocCodes } = useCountryLocCodes();
  const { formId, formField } = getForm(countryLocCodes);

  const exportClient = useExportPrevProjData();

  const handleSubmit = (values: any, actions: any) => {
    exportClient.mutate(values, {
      onSuccess: () => {
        toast.success("Exported successfully!");
      },
      onError: () => {
        toast.error("Failed to export data.");
      },
      onSettled: () => {
        actions.setSubmitting(false);
      },
    });
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={liveFormValues}
        validationSchema={validations}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, isSubmitting }) => {
          const formData = { values, errors, touched, formField };
          return (
            <Form id={formId} autoComplete="off">
              <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <MDTypography variant="h6">One Country to export</MDTypography>
                </AccordionSummary>
                <AccordionDetails>
                  <MDTypography variant="h6" sx={{ whiteSpace: "pre-wrap" }}>
                    Export one country to CSV file:
                  </MDTypography>
                  <MDTypography variant="caption" sx={{ whiteSpace: "pre-wrap" }}>
                    Description: Select a country and export its &apos;Prevalence Breakdown&apos;
                    data in a CSV file. Possibility to select the country, the last year and the
                    period coverage before exporting.
                  </MDTypography>

                  <ExportProjectionsForm formData={formData} />

                  <MDButton
                    disabled={isSubmitting || Object.keys(errors).length > 0}
                    type="submit"
                    variant="gradient"
                    color="dark"
                  >
                    Export
                  </MDButton>
                </AccordionDetails>
              </Accordion>
            </Form>
          );
        }}
      </Formik>
    </>
  );
}

export default ExportPrevProjForm;
